/* Starlog drawer behavior.
 *
 * Auto-close the mobile menu drawer (Baseline's `leftDrawer`) when the user
 * taps an anchor link inside it. Default Baseline behavior leaves the drawer
 * open after navigation, which on mobile feels stuck: the page scrolls
 * underneath but the drawer keeps covering it.
 *
 * Implementation: event delegation on document. We catch any anchor click,
 * check if it originates from inside the open sidebar, and if so close the
 * left drawer via the Alpine store (same API the open button uses).
 *
 * Out-of-scope: links that navigate cross-page (the new page reload closes
 * the drawer naturally), but closing pre-emptively does no harm and keeps
 * behavior consistent for SPA-style anchor links.
 */
(function () {
  if (typeof window === "undefined") return;

  function closeLeftDrawer() {
    /* Strategy 1: call Alpine store close('leftDrawer') directly.
       This is the same API the drawer's backdrop click uses (see
       snippets/left-drawer.liquid line 11). Most reliable path. */
    if (
      window.Alpine &&
      typeof Alpine.store === "function" &&
      Alpine.store("modals") &&
      typeof Alpine.store("modals").close === "function"
    ) {
      try {
        Alpine.store("modals").close("leftDrawer");
        return;
      } catch (_) {}
      try {
        Alpine.store("modals").close("sidebar");
        return;
      } catch (_) {}
    }

    /* Strategy 2: click the X close button inside the rendered slot.
       Same handler, different invocation path. */
    var closeBtn = document.querySelector(
      "#left-drawer-slot button.button__icon"
    );
    if (closeBtn) {
      try {
        closeBtn.click();
        return;
      } catch (_) {}
    }

    /* Strategy 3: Escape key, which the drawer wrapper also listens for. */
    document.dispatchEvent(
      new KeyboardEvent("keydown", { key: "Escape", bubbles: true })
    );
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var anchor = target.closest("a[href]");
      if (!anchor) return;

      /* The rendered drawer's content lives inside #left-drawer-slot
         (Baseline teleports it there via x-teleport). The id="sidebar"
         element is a <template> and inert, so we must match the slot. */
      var slot = anchor.closest("#left-drawer-slot");
      if (!slot) return;

      closeLeftDrawer();
    },
    true
  );
})();
